/*
  SBO — Free Vivier HEXAM Cleanser auto-add
  Campaign: any serum + any sunscreen ($200+ combined) -> free HEXAM (Oct 18 - Nov 9, 2026)
  Works with the Shopify automatic discount "Free Vivier HEXAM Cleanser" (that discount makes HEXAM $0;
  this script only puts HEXAM in the cart / takes it out).
  Built for Dawn-based themes (15.x). Stops itself after the campaign end date.
*/
(function () {
  'use strict';

  // ---- Campaign settings -------------------------------------------------
  var END = new Date('2026-11-10T06:59:00Z');          // Nov 9, 11:59 PM PT
  if (new Date() > END) return;

  var GIFT_VARIANT_ID = 50519760568629;                // Vivier HEXAM Gentle Cleanser 150 ml
  var THRESHOLD_CENTS = 20000;                          // $200.00
  var STATE_KEY = 'sboHexamGift';

  // A cart qualifies when it has at least one SERUM and at least one SUNSCREEN
  // (any quantity) from these lists, and those items total $200 or more.
  // Keep these lists identical to the products in the Shopify discount.
  var SERUMS = [
    9108772749621, // Vivier Serum 10
    9108781924661, // Vivier Kine-C Serum
    9108784054581, // Vivier CE Peptides Serum
    9108785398069, // Vivier QuintiSerum
    9108787167541, // Vivier Radiance Serum
    9108788543797, // Vivier Advanced Skin Lightening Serum
    9108789821749, // Vivier GrenzCine Serum
    9108837171509, // Vivier Ultimage
    9108850082101, // Vivier Redness Solution Complex
    10503433978165 // Vivier Serum 30
    // Optional (Otto to decide) — SkinMedica serums still in stock, no restock before 2028:
    // , 8039308034357 // SkinMedica Lytera 2.0
    // , 8039642595637 // SkinMedica HA5 Rejuvenating Hydrator
    // , 8039680147765 // SkinMedica LUMIVIVE Day/Night
  ];
  var SUNSCREENS = [
    9081932972341, // EltaMD UV Daily SPF 40
    9081937920309, // EltaMD UV Daily Tinted SPF 40
    9081943032117, // EltaMD UV Clear SPF 46
    9081945555253, // EltaMD UV Clear Tinted SPF 46
    9081946538293, // EltaMD UV Physical Tinted SPF 41
    9081939886389, // EltaMD UV Sport SPF 50 (3 oz)
    9081940934965, // EltaMD UV Sport SPF 50 (8 oz)
    9108896678197, // Vivier Sheer SPF 30 Mineral Tinted
    9108898971957, // Vivier Sheer SPF 30 Mineral
    9108901790005  // Vivier Sheer SPF 45
    // Optional (Otto to decide) — Colorescience face SPFs:
    // , 9335494934837 // EnviroScreen Face Shield FLEX SPF 50
    // , 8039394541877 // Even Up Clinical Pigment Perfector SPF 50
    // , 8039385432373 // All Calm Clinical Redness Corrector SPF 50
  ];


  // ---- Helpers -----------------------------------------------------------
  var origFetch = window.fetch.bind(window);
  var busy = false;

  function getState() { try { return sessionStorage.getItem(STATE_KEY) || ''; } catch (e) { return ''; } }
  function setState(v) { try { sessionStorage.setItem(STATE_KEY, v); } catch (e) {} }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function getCart() {
    return origFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function post(url, body) {
    return origFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('cart request failed ' + r.status);
      return r.json();
    });
  }

  // Re-draw the cart drawer and cart icon after we change the cart (Dawn section rendering)
  function refreshCartUI() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return Promise.resolve(); }
    return origFetch(location.pathname + '?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var parser = new DOMParser();
        if (s['cart-drawer']) {
          var fresh = parser.parseFromString(s['cart-drawer'], 'text/html').querySelector('#CartDrawer');
          var current = document.querySelector('#CartDrawer');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          var drawer = document.querySelector('cart-drawer');
          if (drawer) {
            drawer.classList.remove('is-empty');
            var overlay = document.querySelector('#CartDrawer-Overlay');
            if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
          }
        }
        if (s['cart-icon-bubble']) {
          var bubble = parser.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          var currentBubble = document.getElementById('cart-icon-bubble');
          if (bubble && currentBubble) currentBubble.innerHTML = bubble.innerHTML;
        }
      })
      .catch(function () {});
  }

  // Small message at the top of the cart drawer footer and the cart page footer
  function renderNotice(st, hasGift) {
    var text;
    if (st.ok) {
      text = hasGift
        ? '\uD83C\uDF81 Your free Vivier HEXAM Cleanser is in your cart.'
        : '\uD83C\uDF81 You qualify for a free Vivier HEXAM Cleanser \u2014 add it to your cart. No code needed.';
    } else if (st.serum && !st.spf) {
      text = 'Add any sunscreen to get a free Vivier HEXAM Cleanser.';
    } else if (st.spf && !st.serum) {
      text = 'Add any serum to get a free Vivier HEXAM Cleanser.';
    } else if (st.serum && st.spf) {
      text = 'You\u2019re ' + money(THRESHOLD_CENTS - st.total) + ' away from a free Vivier HEXAM Cleanser.';
    } else {
      text = 'Buy any serum + any sunscreen ($200+) \u2014 get a free Vivier HEXAM Cleanser.';
    }
    ['#CartDrawer .drawer__footer', '.cart__footer'].forEach(function (sel) {
      var host = document.querySelector(sel);
      if (!host) return;
      var el = host.querySelector('.sbo-gift-note');
      if (!el) {
        el = document.createElement('p');
        el.className = 'sbo-gift-note';
        el.style.cssText = 'margin:0 0 1rem;padding:.8rem 1rem;background:#f4f1ec;border-radius:6px;font-size:1.3rem;line-height:1.4;';
        host.insertBefore(el, host.firstChild);
      }
      el.textContent = text;
    });
  }

  // ---- Main check --------------------------------------------------------
  function check() {
    if (busy) return;
    busy = true;
    getCart().then(function (cart) {
      var total = 0, hasSerum = false, hasSpf = false;
      var giftLine = null;
      cart.items.forEach(function (it) {
        if (it.variant_id === GIFT_VARIANT_ID) { if (!giftLine) giftLine = it; return; }
        if (SERUMS.indexOf(it.product_id) !== -1) { hasSerum = true; total += it.original_line_price; }
        else if (SUNSCREENS.indexOf(it.product_id) !== -1) { hasSpf = true; total += it.original_line_price; }
      });
      var status = { total: total, serum: hasSerum, spf: hasSpf, ok: hasSerum && hasSpf && total >= THRESHOLD_CENTS };
      var state = getState();
      var qual = status;

      if (status.ok) {
        if (giftLine) { setState('added'); renderNotice(qual, true); return; }
        // We added it before and it's gone while still qualifying = shopper removed it on purpose
        if (state === 'added') setState('declined');
        if (getState() === 'declined') { renderNotice(qual, false); return; }
        return post('/cart/add.js', {
          items: [{ id: GIFT_VARIANT_ID, quantity: 1, properties: { _sbo_gift: 'yes' } }]
        })
          .then(function () { setState('added'); return refreshCartUI(); })
          .then(function () { renderNotice(qual, true); })
          .catch(function () { renderNotice(qual, false); });
      }

      // Below $200: take out only the gift line this script added
      if (giftLine && giftLine.properties && giftLine.properties._sbo_gift === 'yes') {
        return post('/cart/change.js', { id: giftLine.key, quantity: 0 })
          .then(function () { setState(''); return refreshCartUI(); })
          .then(function () { renderNotice(qual, false); });
      }
      if (state === 'declined') setState('');
      renderNotice(qual, !!giftLine);
    }).catch(function () {}).then(function () { busy = false; });
  }

  // Re-check whenever the theme changes the cart
  window.fetch = function (input, init) {
    var p = origFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(check, 300); }).catch(function () {});
      }
    } catch (e) {}
    return p;
  };

  check();
})();